import { render } from "./CpsTextarea.vue?vue&type=template&id=8da3e8e0&scoped=true&ts=true"
import script from "./CpsTextarea.vue?vue&type=script&lang=ts"
export * from "./CpsTextarea.vue?vue&type=script&lang=ts"

import "./CpsTextarea.vue?vue&type=style&index=0&id=8da3e8e0&scoped=true&lang=css"

import exportComponent from "/app/higgs.cps.portal.website/node_modules/.pnpm/vue-loader@16.8.3_f65c6e1beb608835961423903ad857fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8da3e8e0"]])

export default __exports__